import * as React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { SkeletonLoadingWrapper, MarginTop } from '@atlassian/help-center-common-component/loading';
import { withAsync } from '@atlassian/help-center-common-component/with-async';
import { withFadeIn } from '@atlassian/help-center-common-component/with-fade-in';

const MarginWrapper = () => {
    return (
        <MarginTop>
            <SkeletonLoadingWrapper />
        </MarginTop>
    );
};

const loader = lazyForPaint(
    () =>
        import(/* webpackChunkName: "request-create-form" */ './request-create-form-dumb').then((module) =>
            withFadeIn()(module.default)
        ),
    {
        ssr: false,
    }
);

export default withAsync({
    loader,
    loadingPosition: 'static',
    LoadingSkeleton: MarginWrapper,
});
